export function getMessageCacheUsage(message) {
  const raw = message?.cache_usage ?? message?.cacheUsage ?? null;
  if (!raw || typeof raw !== 'object') return null;
  const entries = Array.isArray(raw.entries)
    ? raw.entries.filter((entry) => entry && entry.hit === true)
    : [];
  if (entries.length === 0) return null;
  return { entries };
}

export function messageHasCacheUsage(message) {
  return Boolean(getMessageCacheUsage(message)?.entries?.length);
}

export function formatCacheEntryPreview(entry) {
  const key = entry?.key && typeof entry.key === 'object' ? entry.key : {};
  const preview =
    key.segmentText ||
    key.inputText ||
    key.sourceText ||
    key.input ||
    '';
  const text = String(preview || '').trim();
  if (!text) return '';
  return text.length > 120 ? `${text.slice(0, 117)}…` : text;
}

export function mergeCacheUsageIntoMessage(message, clientCacheUsage, assistantCacheUsage) {
  if (!message || typeof message !== 'object') return message;
  const isClient = String(message.sender || '').toLowerCase() === 'client';
  const usage = isClient ? clientCacheUsage : assistantCacheUsage;
  if (!usage || !Array.isArray(usage.entries) || usage.entries.length === 0) {
    return message;
  }
  return { ...message, cache_usage: usage };
}
